<section class="workshop-cta-section">
  <div class="container">
    <div class="row align-items-center">

      <!-- Left Content -->
      <div class="col-lg-6 col-md-6">
        <div class="workshop-content">

          <h1 class="workshop-title">
            Host the workshop. <br />
            <span class="highlight-italic">Anchor</span> your university in <br />
            India's AI future.
          </h1>

          <p class="workshop-desc">
            A short nomination form is all it takes. The programme team responds
            within five working days with next steps for hosting the on-campus
            workshop.
          </p>
          <div class="workshop-btns">
            <button class="btn-white-custom" (click)="navigateToRegister()">Register Interest</button>
          </div>

        </div>
      </div>

      <!-- Right Image -->
      <div class="col-lg-6 col-md-6">
        <div class="workshop-image-wrapper">
          <img
            [src]="workshopAssets.studentImage"
            alt="Workshop Students"
          />
        </div>
      </div>

    </div>
  </div>
</section>